import { Navigate, useLocation, useParams } from "react-router-dom";
import { urls } from "../../../urls";
import { ContractPage } from "./ContractPage";

export const ContractViewRoute = () => {
  const { contractId } = useParams();
  const location = useLocation();

  if (contractId) {
    return <Navigate to={`${urls.v2.contracts.view.go(contractId)}${location.search}${location.hash}`} replace />;
  }

  return <ContractPage />;
};
